import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { formatTodayWorkingHours, getUserWorkingHoursURL } from '../../working-hours/utils/workingHoursUtils';
import UILink from 'UIComponents/link/UILink';
import { Bold } from '../../shared/components/Bold';
import { HS_WORKING_HOURS, HS_STANDARD_TIME_ZONE } from '../../working-hours/constants';
import usePropertyOptions from '../../working-hours/hooks/usePropertyOptions';
import { useUserPropertyValue } from '../../working-hours/hooks/useUserPropertyValue';
import { getParsedJsonPropertyValue } from '../../working-hours/records/CrmObject';
import { formatTimezoneList } from '../../working-hours/utils/timezoneUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const WorkingHoursToggleTooltip = ({
  userId,
  isUngatedForOutOfOffice,
  children
}) => {
  const {
    value: workingHours
  } = useUserPropertyValue(userId, HS_WORKING_HOURS, getParsedJsonPropertyValue);
  const {
    value: userTimezone
  } = useUserPropertyValue(userId, HS_STANDARD_TIME_ZONE);
  const {
    propertyOptions: timezoneList
  } = usePropertyOptions(HS_STANDARD_TIME_ZONE);
  const timezoneListFormatted = formatTimezoneList(timezoneList);
  const {
    formattedWorkingHours,
    formattedTimezone
  } = formatTodayWorkingHours(workingHours, userTimezone, timezoneListFormatted);
  if (isUngatedForOutOfOffice && !workingHours) {
    // user does not have WH set up
    return /*#__PURE__*/_jsx(UITooltip, {
      title: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "routing-ui.agent-status.workingHoursNotSetTooltip_jsx",
        elements: {
          UILink,
          Bold
        },
        options: {
          linkProps: {
            href: getUserWorkingHoursURL(userId),
            external: true
          }
        }
      }),
      children: children
    });
  } else if (formattedWorkingHours) {
    // user has working hours today
    return /*#__PURE__*/_jsx(UITooltip, {
      use: "longform",
      placement: "bottom",
      headingText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "routing-ui.agent-status.workingHoursTooltipHeader"
      }),
      title: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "routing-ui.agent-status.workingHoursTooltip_jsx",
        elements: {
          UILink,
          Bold
        },
        options: {
          linkProps: {
            href: getUserWorkingHoursURL(userId),
            external: true
          },
          workingHoursList: formattedWorkingHours,
          timezone: formattedTimezone
        }
      }),
      children: children
    });
  } else {
    return children;
  }
};
WorkingHoursToggleTooltip.displayName = 'WorkingHoursToggleTooltip';